// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TDeletePortalConversationFileRequestPayload,
  TDeletePortalConversationFileResponsePayload,
  TGetPortalConversationRequestPayload,
  TGetPortalConversationResponsePayload,
  TListPortalConversationsRequestPayload,
  TListPortalConversationsResponsePayload,
  TUploadPortalConversationFileRequest,
  TUploadPortalConversationFileResponsePayload,
} from './portal-agent.types.ts';

export const createPortalAgentApi = (transport: TApiTransport) => ({
  /** Deletes a staged portal-agent conversation file */
  deletePortalConversationFile: (
    payload: TDeletePortalConversationFileRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeletePortalConversationFileRequestPayload,
      TDeletePortalConversationFileResponsePayload
    >('/delete_portal_conversation_file', payload, options),

  /** Returns a portal-agent conversation */
  getPortalConversation: (
    payload: TGetPortalConversationRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetPortalConversationRequestPayload,
      TGetPortalConversationResponsePayload
    >('/get_portal_conversation', payload, options),

  /** Lists portal-agent conversations */
  listPortalConversations: (
    payload: TListPortalConversationsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListPortalConversationsRequestPayload,
      TListPortalConversationsResponsePayload
    >('/list_portal_conversations', payload, options),

  /** Uploads a file to a portal-agent conversation */
  uploadPortalConversationFile: (
    payload: TUploadPortalConversationFileRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUploadPortalConversationFileRequest,
      TUploadPortalConversationFileResponsePayload
    >('/upload_portal_conversation_file', payload, {
      ...options,
      contentType: 'multipart/form-data',
    }),
});
